import { useCallback } from 'react';
import { AppActionType } from '../components/AppContextProvider/app-reducer';
import { Mode, type ModeSwitchHandler, TripsPanelState, type TripsPanelStateManager } from '../types';
import { useAppDispatch } from '../components/AppContextProvider/AppContextProvider';
import { type Timestamp } from '../services/Timestamp';

export const useModeSwitches = (
  tripsPanelState: TripsPanelState | undefined,
  tripsPanelStateManager: TripsPanelStateManager,
  isMobileView: boolean,
  handleSetTimestamp: (timestamp?: Timestamp) => void,
  setIsDraggingScrubber: (isDragging: boolean) => void
): ModeSwitchHandler => {
  const appDispatch = useAppDispatch();

  const switchToLiveview = useCallback((): void => {
    appDispatch({
      type: AppActionType.SET_MODE,
      payload: {
        mode: Mode.Liveview,
      },
    });
    handleSetTimestamp();
    setIsDraggingScrubber(false);

    if (tripsPanelState === TripsPanelState.Reopen) {
      tripsPanelStateManager.open();
    }
  }, [tripsPanelState, tripsPanelStateManager.open]);

  const switchToPlayback = useCallback((): void => {
    appDispatch({
      type: AppActionType.SET_MODE,
      payload: {
        mode: Mode.Playback,
      },
    });
    setIsDraggingScrubber(false);

    if (isMobileView) {
      tripsPanelStateManager.closeToReopen();
    }
  }, [isMobileView, tripsPanelStateManager.closeToReopen]);

  return { switchToLiveview, switchToPlayback };
};
